import React, { useContext, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import { ReportFranchiseeContext } from "../../context/ReportFranchiseeContext";

export default function SimplePaper() {
  const { valuesDash, optionsStatus } = useContext(ReportFranchiseeContext);
  const [arrayValues, setArrayValues] = useState([]);

  useEffect(() => {
    const copyOptionsStatus = [...optionsStatus];

    copyOptionsStatus.forEach(element => {
      element.Qtd = 0;
    });

    Object.keys(valuesDash).map(i => {
      const index = copyOptionsStatus.findIndex(
        option => option.Id === valuesDash[i].Id
      );

      if (index !== -1) {
        copyOptionsStatus[index].Qtd += 1;
      }

      return null;
    });

    setArrayValues(copyOptionsStatus);
  }, [valuesDash, optionsStatus]);

  return (
    <div className="container-paper">
      {arrayValues.map((item, index) => (
        <Paper key={index} elevation={3} className="paper">
          <label>{item.Descricao}</label>
          <label>{item.Qtd || 0}</label>
        </Paper>
      ))}
    </div>
  );
}
